import { render, staticRenderFns } from "./schoolcontentThree.vue?vue&type=template&id=5deb78a9&scoped=true"
import script from "./schoolcontentThree.vue?vue&type=script&lang=js"
export * from "./schoolcontentThree.vue?vue&type=script&lang=js"
import style0 from "./schoolcontentThree.vue?vue&type=style&index=0&id=5deb78a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deb78a9",
  null
  
)

export default component.exports